export default __webpack_public_path__ + "static/media/KamiliantbyAmericanTourister1.015b9bc6.jpeg";